<template>
  <div >
    <TheNavbar />
    <main m-0>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <transition
              enter-active-class="animate__animated animate__fadeIn"
              leave-active-class="animate__animated animate__fadeOut"
              mode="out-in"
              appear
              :key="$route.path"
              ><slot v-if="true"></slot></transition>
          </div>
        </div>
        <TheFooter   />
      </div>
    </main>
  </div>
</template>

<script>
import TheNavbar from "@/components/TheNavbar";
import TheFooter from "@/components/TheFooter";

export default {
  name: "Layout",
  components: {
    TheNavbar,
    TheFooter,
  },
};
</script>

<style scoped>
</style>